/* eslint-disable no-underscore-dangle */
import { makeEntityScaffold } from '@classpass/saga-tools';
import _isNil from 'lodash/isNil';
import URLS from 'constants/urls';
import { transformClientResponse, formatUserInfo } from 'helpers/core';

const resetPassword = (httpClient, password, resetToken) => {
  const endpoint = URLS.user.resetPassword(resetToken);

  httpClient.post(endpoint, { password, repeat_password: password });
};

const forgotPassword = (httpClient, email) => {
  return httpClient.post(URLS.user.forgotPassword, { email });
};

const login = (httpClient, email, password) => {
  return httpClient
    .post(URLS.user.logIn, { email, password }, { logErrorToDatadog: status => status !== 401 })
    .then(transformClientResponse);
};

const get = async httpClient => {
  // this and helpers/core/formatUserInfo need to be kept in sync
  const user = await httpClient.get(URLS.user.info).then(transformClientResponse);
  return formatUserInfo(user);
};

const handler = ({ httpClient }, data = {}) => {
  const { email, password, resetToken } = data;
  const hasEmail = !_isNil(email);
  const hasPassword = !_isNil(password);
  const hasResetToken = !_isNil(resetToken);

  if (hasEmail && hasPassword) {
    return login(httpClient, email, password);
  }

  if (hasEmail) {
    return forgotPassword(httpClient, email);
  }

  if (hasPassword && hasResetToken) {
    return resetPassword(httpClient, password, resetToken);
  }

  return get(httpClient);
};

export default makeEntityScaffold('USER_INFO', handler, {
  defaultKey: (client, { email, password, resetToken } = {}) =>
    email || password || resetToken ? 'postRequest' : 'default',
});
